/* Holiday Gift Guide — page behaviour shared by the gift-guide-* sections.
   - Season state: the hero's [data-gg-season] holds the five start times
     (YYYYMMDDHHmm in its time zone). The state drives the deadline bar and hero
     line (CSS), the delivery table rows, and in "egift" moves the gift card
     section up under the nav. ?state=default|std|twoday|overnight|egift previews one.
   - Price filter: chips hide cards outside the band, then empty sections and
     their nav links, and update each section's gift count.
   - Sticky nav: underlines the link of the section in view.
   - Gift card: the picked amount updates the button label.
   Add to cart itself is mutha-lp-cart-button.js (opens Horizon's cart drawer). */
(function () {
  if (window.__giftGuideLoaded) return;
  window.__giftGuideLoaded = true;

  var ORDER = ['default', 'std', 'twoday', 'overnight', 'egift'];
  var currentFilter = 'all';
  var navObserver = null;

  function designMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  /** @returns {number | null} Now as YYYYMMDDHHmm in the given time zone. */
  function nowNumber(timeZone) {
    try {
      var p = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      })
        .formatToParts(new Date())
        .reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
      return Number(p.year + p.month + p.day + p.hour + p.minute);
    } catch (e) {
      return null;
    }
  }

  function seasonState(cfg) {
    var forced = new URLSearchParams(window.location.search).get('state');
    if (ORDER.indexOf(forced) > -1) return forced;
    var now = nowNumber(cfg.dataset.timezone || 'America/New_York');
    if (!now) return cfg.getAttribute('data-gg-state') || 'default';
    var at = function (key) { return Number(cfg.dataset[key]) || 0; };
    if (at('end') && now >= at('end')) return 'default';
    if (at('egift') && now >= at('egift')) return 'egift';
    if (at('overnight') && now >= at('overnight')) return 'overnight';
    if (at('twoday') && now >= at('twoday')) return 'twoday';
    if (at('std') && now >= at('std')) return 'std';
    return 'default';
  }

  function applyState() {
    var cfg = document.querySelector('[data-gg-season]');
    if (!cfg) return;
    var state = seasonState(cfg);
    var idx = ORDER.indexOf(state);

    document.querySelectorAll('[data-gg-state]').forEach(function (el) {
      el.setAttribute('data-gg-state', state);
    });

    document.querySelectorAll('[data-gg-tier]').forEach(function (row) {
      var i = ORDER.indexOf(row.getAttribute('data-gg-tier'));
      var past = idx >= 1 && i >= 1 && i < idx;
      row.classList.toggle('is-now', i === idx);
      row.classList.toggle('is-past', past);
      var label = row.querySelector('[data-gg-past-label]');
      if (label) label.hidden = !past;
    });

    /* In the editor, sections stay where the merchant put them. */
    if (state !== 'egift' || designMode()) return;
    var gc = document.querySelector('[data-gg-giftcard]');
    var first = document.querySelector('[data-gg-circle]');
    if (!gc || !first) return;
    var gcWrap = gc.closest('.shopify-section') || gc;
    var firstWrap = first.closest('.shopify-section') || first;
    if (gcWrap === firstWrap) return;
    if (firstWrap.compareDocumentPosition(gcWrap) & Node.DOCUMENT_POSITION_FOLLOWING) {
      firstWrap.parentNode.insertBefore(gcWrap, firstWrap);
    }
  }

  function applyFilter(filter) {
    currentFilter = filter;
    var shown = 0;
    document.querySelectorAll('[data-gg-band]').forEach(function (card) {
      var hide = filter !== 'all' && card.getAttribute('data-gg-band') !== filter;
      card.hidden = hide;
      if (!hide) shown++;
    });

    var emptyIds = {};
    document.querySelectorAll('[data-gg-circle]').forEach(function (sec) {
      var any = sec.querySelector('[data-gg-band]:not([hidden])');
      sec.classList.toggle('is-empty', !any);
      if (!any && sec.id) emptyIds[sec.id] = true;
      var count = sec.querySelector('[data-gg-count]');
      if (count) {
        var n = sec.querySelectorAll('.gg-grid [data-gg-band]:not([hidden])').length;
        count.textContent = n + ' ' + (n === 1 ? count.dataset.one : count.dataset.many);
      }
    });

    document.querySelectorAll('[data-gg-nav-links] a').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      a.hidden = href.charAt(0) === '#' && Boolean(emptyIds[href.slice(1)]);
    });

    document.querySelectorAll('[data-gg-f]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(chip.getAttribute('data-gg-f') === filter));
    });

    var nav = document.querySelector('[data-gg-filter]');
    var note = document.querySelector('[data-gg-filter-note]');
    if (nav && note) {
      note.textContent = filter === 'all'
        ? ''
        : (nav.dataset.note || '')
            .replace('[count]', shown)
            .replace('[band]', nav.getAttribute('data-band-' + filter) || '');
    }
  }

  function setupNav() {
    if (navObserver) navObserver.disconnect();
    var strip = document.querySelector('[data-gg-nav-links]');
    if (!strip || !('IntersectionObserver' in window)) return;
    var links = {};
    strip.querySelectorAll('a').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1) links[href.slice(1)] = a;
    });
    navObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var a = links[e.target.id];
        if (!e.isIntersecting || !a) return;
        Object.keys(links).forEach(function (k) {
          var on = k === e.target.id;
          links[k].classList.toggle('is-on', on);
          if (on) links[k].setAttribute('aria-current', 'true');
          else links[k].removeAttribute('aria-current');
        });
        /* Scroll the link strip only. scrollIntoView() also scrolls the window
           and fights the sticky nav. */
        strip.scrollTo({ left: Math.max(0, a.offsetLeft - strip.offsetLeft - 24), behavior: 'smooth' });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(links).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) navObserver.observe(el);
    });
  }

  function updateGiftCardLabel(input) {
    var form = input.form;
    var label = form && form.querySelector('[data-gg-gc-label]');
    if (!label) return;
    label.textContent = (label.getAttribute('data-gg-gc-label') || '').replace('[amount]', input.getAttribute('data-gg-amt') || '');
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-gg-f]');
    if (chip) applyFilter(chip.getAttribute('data-gg-f'));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-gg-amt]')) updateGiftCardLabel(e.target);
  });

  function init() {
    applyState();
    applyFilter(currentFilter);
    setupNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-run after the theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', init);
})();
